import {TabConfigStructure} from '../tab-config-structure';
import {FilterPortalConfig} from '../filters/filter-portal-config.model';

export class WorkConfig {

  bookConfig: TabConfigStructure[] = [];

  filtersConfig: FilterPortalConfig[] = [];

  articlesConfig: FilterPortalConfig[] = [];

  topicsConfig: FilterPortalConfig[] = [];
}
